import { styled, Button } from "@mui/material";

const GlowButton = styled(Button)(({ theme }) => ({
  "&:hover": {
    backgroundColor: theme.palette.common.glowColor,
  },
}));

export default GlowButton;
